// This is needed by the class-transformer package at a global scope
import 'reflect-metadata';

import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';

import { Observable } from 'rxjs';

import { AppId, NavigationArea, PlatformNavigationComponent, RouteResolverService } from '@skykick/core';

import { AppService } from './app.service';
import { InitializationService } from './initialization.service';

@Component({
    selector: '[sk-root]',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, AfterViewInit {
    readonly portalUri: string;

    get loading$(): Observable<boolean> {
        return this.appService.loading$;
    }

    constructor(
        private readonly appService: AppService,
        private readonly routeResolverService: RouteResolverService,
        private readonly initializationService: InitializationService
    ) {
        this.portalUri = this.routeResolverService.generateRatRoute(AppId.Portal);
    }

    @ViewChild(PlatformNavigationComponent)
    public platformNav: PlatformNavigationComponent;

    ngOnInit(): void {
        // Runs here (not in a provideAppInitializer) so AbstractUserProvider.getCurrentUser() is
        // only called once every APP_INITIALIZER - including AuthModule's identity session
        // bootstrap - has already resolved. See app.module.ts / initialization.service.ts.
        void this.initializationService.run();
    }

    ngAfterViewInit(): void {
        this.platformNav.SkNavigationArea = NavigationArea.Admin;
    }
}
